angular.module('jv.Admin.Users')
    .controller('jvAdminUserMainController', ['$scope', function ($scope) {
         $scope.objectSize = function(obj){
            return objectSize(obj);
        };
    }]);
